import React from "react";
import { useStoreSettings } from "../../../../../../../hooks/useStoreSettings";
import { useLanguage } from "../../../../../../../context/LanguageContext";
import { useAdminProductsTranslation } from "../../../../translations";

// DiscountTypeSelector Component
export const DiscountTypeSelector = ({ discountType, onChange }) => {
    // Get store settings for currency
    const { currency: storeCurrency } = useStoreSettings();
    const { language } = useLanguage();
    const { t } = useAdminProductsTranslation(language);

    return (
        <div className="form-group">
            <label>{t('discountType')}</label>
            <div className="radio-group">
                <label className="radio-label">
                    <input
                        type="radio"
                        value="percentage"
                        checked={discountType === "percentage"}
                        onChange={(e) => onChange(e.target.value)}
                    />
                    {t('percentage')} (%)
                </label>
                <label className="radio-label">
                    <input
                        type="radio"
                        value="fixed"
                        checked={discountType === "fixed"}
                        onChange={(e) => onChange(e.target.value)}
                    />
                    {t('fixedAmount')} ({storeCurrency || 'AED'})
                </label>
            </div>
        </div>
    );
};
// Exporting the component
export default DiscountTypeSelector;